<template>
    <main>
        <div class="row">
            <div class="mr-0 pr-0 col-xs-12 col-sm-12 col-md-4 col-lg-4">
                <div class="input-group input-group-sm">
                    <input
                        ref="myInput"
                        type="text"
                        class="form-control form-control-sm"
                        :readonly="isSearch"
                        v-on:keyup.enter.prevent="getServicioByCodigo()"
                        v-model="codigo"
                        :class="{'is-invalid': v.$error,'is-valid': !v.$error && v.$dirty,}"
                    />
                    <div class="input-group-append">
                        <button class="btn btn-primary"
                                data-toggle="modal"
                                :data-target="`#${random_modal_id}`"
                                tabindex="-1"
                                @click="component='SearchServicioComponent'"
                        >
                            <i class="fas fa-search"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="ml-0 pl-1 col-xs-12 col-sm-12 col-md-8 col-lg-8">
                <input
                    type="text"
                    class="form-control form-control-sm"
                    disabled
                    v-model="servicio.descripcion"
                />
            </div>
        </div>
        <div class="modal fade " :id="random_modal_id" tabindex="-1" role="dialog" aria-labelledby="buscarServicio" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Buscar Servicio</h4>
                        <button type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="component='SearchServicioComponent'">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <component @select="onSelect($event)" :is="component"></component>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import ServiceFactory from "../../services/ServiceFactory";
import SearchServicioComponent from "./SearchServicioComponent";
const ServiciosService = ServiceFactory.get("servicios");
import {isEmpty} from 'lodash';
import $ from 'jquery';

export default {
    components: {SearchServicioComponent},
    props: ["value", "tarifa", "v"],
    data() {
        return {
            codigo: "",
            servicio: this.value,
            isSearch: false,
            random_modal_id : '',
            component : '',
        };
    },
    created() {
        const random_number = Math.floor(Math.random() * ((100+1)-1)+1);
        this.random_modal_id = `search_servicio_modal_${random_number}`;
    },
    watch: {
        value: {
            handler: function (newValue) {
                this.servicio = newValue;
                if (Object.entries(newValue).length === 0) {
                    this.codigo = "";
                }
            },
            deep: true,
        },
    },
    methods: {
        async getServicioByCodigo() {
            this.isSearch = true;

            let response = null;

            if (this.tarifa !== "") {
                response = await ServiciosService.getByCodigo(this.codigo, this.tarifa);
            } else {
                response = await ServiciosService.getByCodigo(this.codigo);
            }

            this.isSearch = false;

            if (!isEmpty(response.data)) {
                this.servicio = response.data;
                this.$emit("input", this.servicio);
            }

            this.validate();
        },
        setChange(value) {
            this.$emit("update-value", value);
        },
        validate() {
            if (this.v !== undefined && this.v !== null) {
                this.v.$touch();
            }
        },
        onSelect(value){
            this.codigo = value.codigo;
            this.getServicioByCodigo();
            $(`#${this.random_modal_id}`).modal('hide');
        }
    },
};
</script>
<style scoped>
</style>
